/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import cssClasses from "./Login.module.css";
import strip1 from "../../Assets/Images/Login/strip1.svg";
import strip2 from "../../Assets/Images/Login/strip2.svg";
import strip3 from "../../Assets/Images/Login/strip3.svg";
import strip4 from "../../Assets/Images/Login/strip4.svg";
import logo from "../../Assets/Images/SideMenu/vjLogo.jpg";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";

import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";

import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

//*react-phone-number-input
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import debounce from "lodash.debounce";

import { checkPhoneNoExists, checkPhoneNumberIsBlackListed, getLead, logIn } from "../../Services/Login";
import { sendOtp, setLoggedInUser } from "../../Services/OtpAuth";

import { errorTost } from "../../Services/Toast";
import { sendOTPMessage } from "../../Services/SmsService";
import CryptoJS from "crypto-js";
import actions from "../../Redux Store/actions";
import { Card } from "@mui/material";
import { useEffect } from "react";
import TermsAndCondition from "../../Modals/TermsAndConditions/TermsAndCondition";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import { orderBy, sortBy } from "lodash";
import { supabase } from "../../supabaseClient";
import { dismissLoader, presentLoader } from "../../Services/loader";

const useStyles = makeStyles((theme) => ({
	title: {
		color: "#1C1C1C",
		fontFamily: "Inter-Medium",
		fontSize: "2.4rem",
		lineHeight: "3.2rem",
		marginBottom: "1rem",
	},
	radioLabel: {
		fontFamily: "Inter-Medium !important",
		fontSize: "1.4rem",
		lineHeight: "2.5rem",
		whiteSpace: "nowrap",
	},
	subTitle: {
		color: "#667085",
		fontFamily: "Inter-Regular",
		fontSize: "1.4rem",
		lineHeight: "2.2rem",
	},
	label: {
		display: "inline-block",
		fontFamily: "Inter-Medium",
		fontWeight: "400",
		fontSize: "1.4rem",
		lineheight: "2rem",
		/* identical to box height, or 143% */

		/* Gray/500 */

		color: "#667085",
		marginRight: "0.4rem",
	},
	signUp: {
		display: "inline-block",
		fontFamily: "Inter-Medium",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineheight: "2rem",
		cursor: "pointer",
		color: "#175CD3",
	},
}));
const Login = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const classes = useStyles();

	const [mobileNo, setMobileNo] = useState("");
	const [contactNo, setPersonContactNo] = useState("");
	const [selectedLead, setSelectedLead] = useState(null);
	const [isLoginLoading, setIsLoginLoading] = useState(false);
	const [helperText, setHelperText] = useState({
		isPhoneNumber: "",
	});
	const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
	const [enableOtp, setEnableOtp] = useState(false);
	const [showOtp, setShowOtp] = useState(false);
	const [state, setState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [isInterNational, setIsInterNational] = useState(false);
	const [recievedOtp, setRecievedOtp] = useState(null);
	const [otptimer, setOtpTimer] = useState(false);
	const [resendButton, setResendButton] = useState(false);
	const [showTimer, setShowTimer] = useState(false);
	const [showLeadList, setShowLeadList] = useState(false);
	const [leadsList, setLeadsList] = useState([]);
	const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(false);
	const [termsAndConditionModal, setTermsAndConditionModal] = useState(false);
	// useEffect(() => {
	//     getLeadDetails();
	// }, []);
	// // !!Snapshort For Leads Array

	useEffect(() => {
		let leadList = JSON.parse(localStorage.getItem("LeadList")) || [];
		let leadIds = leadList.map((el) => (el?.Leads.length > 0 ? el?.Leads[0]?.leadId : null)).filter(Boolean);

		console.log({ leadIds, leadsList });
		let updateStatusListeners = supabase
			.from(`LeadStatus:leadId=in.(${leadIds})`)
			.on("UPDATE", (handleRecordUpdated) => {
				const updatedLeadList = JSON.parse(localStorage.getItem("LeadList")) || [];
				setMobileNo(updatedLeadList[0]?.contactNumber);
				leadList = JSON.parse(localStorage.getItem("LeadList"));
				leadList.forEach((el) => {
					leadIds.push(el?.Leads.length > 0 ? el?.Leads[0]?.leadId : []);
				});
				getLeadDetails();
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		return () => {
			if (updateStatusListeners) {
				supabase.removeSubscription(updateStatusListeners);
				updateStatusListeners = null;
			}
		};
	}, []);

	function defineColorSchema(status) {
		console.log("status", status);
		let obj = {};
		if (status === "Claimed") {
			obj.chipColor = "#FF4405";
			obj.chipBackgroundColor = "#FFE6D5";
		} else if (status === "Site Visit Done" || status === "Token Partial Payment Done" || status === "Token Refund Requested") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "Site Visit Scheduled") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "Site Visit Pending") {
			obj.chipColor = "#0E7090";
			obj.chipBackgroundColor = "#ECFDFF";
		} else if (status === "Token Payment Not Done") {
			obj.chipColor = "#C11574";
			obj.chipBackgroundColor = "#FDF2FA";
		} else if (status === "Token Payment Pending" || status === "Token Refund Request Rejected" || status === "Token Payment Complete") {
			obj.chipColor = "#3538CD";
			obj.chipBackgroundColor = "#EEF4FF";
		} else if (status === "Token Refunded") {
			obj.chipColor = "#3538CD";
			obj.chipBackgroundColor = "#EEF4FF";
		} else if (status === "Checkpoint One Cleared") {
			obj.chipColor = "#6941C6";
			obj.chipBackgroundColor = "#F4EBFF";
		} else if (status === "Checkpoint Two Cleared") {
			obj.chipColor = "#0E7090";
			obj.chipBackgroundColor = "#ECFDFF";
		} else if (status === "Allotment Partial Payment Done" || status === "Allotment Refunded" || status === "Preselect payment not done") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Unit On Hold") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Allotment Payment Pending" || status === "Payment Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "Change Unit Confirmation Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (
			status === "Allotment Payment Complete" ||
			status === "Change Unit Requested" ||
			status === "Agreement Done" ||
			status.includes("Cancellation Confirmation Pending") ||
			status === "Cancel Unit Done" ||
			status === "Cancel Unit Not Done" ||
			status === "Cancellation Done" ||
			status === "Cancellation Not Done" ||
			status === "Change Unit Confirmation Rejected" ||
			status === "Change Unit Confirmed" ||
			status === "Change Unit Rejected" ||
			status === "Cancel Unit Requested" ||
			status === "PreSelect Unit On Hold" ||
			status === "Preselect not confirmed" ||
			status === "PreSelect Partial Payment Done" ||
			status === "PreSelect Price Confirmation Pending" ||
			status === "Unit Change Requested"
		) {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else if (status === "PreSelect Price Confirmation Pending" || status === "PreSelect Confirmation Pending") {
			obj.chipColor = "#C01048";
			obj.chipBackgroundColor = "#FFF1F3";
		} else if (status === "PreSelect Payment Pending") {
			obj.chipColor = "#6941C6";
			obj.chipBackgroundColor = "#F4EBFF";
		} else if (status === "Closed") {
			obj.chipColor = "#027A48";
			obj.chipBackgroundColor = "#ECFDF3";
		} else if (status === "Allotment Done") {
			obj.chipColor = "#5925DC";
			obj.chipBackgroundColor = "#F4F3FF";
		} else {
			obj.chipBackgroundColor = " #ececec";
			// obj.chipColor = "#667085";
		}

		return obj;
	}

	const IsNumberBlackListed = debounce((e) => {
		checkPhoneNumberIsBlackListed(e)
			.then((resp) => {
				if (resp.isBlacklisted) {
					setVerifiedPhoneNumber(false);
					setHelperText((pre) => {
						// ! this is for dev purpose only; to be removed when deploying
						// pre.isPhoneNumber = "";
						// setEnableOtp(true);
						// ! show error msg if blacklisted
						// ! this is for dev purpose only; to be uncommented when deploying
						pre.isPhoneNumber = "This number is not authorized!";
						return { ...pre };
					});
					// helperText.isPhoneNumber = "This number has been blacklisted";
				} else {
					setHelperText((pre) => {
						pre.isPhoneNumber = "";
						return { ...pre };
					});
					setEnableOtp(true);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, 800);
	function getLeadDetails() {
		// setIsLoginLoading(true);
		let leadMobileNo = mobileNo.substring(1, 10) + mobileNo.substring(10, mobileNo.toString().length);
		leadMobileNo = parseInt(leadMobileNo);
		getLead(leadMobileNo).then((resp) => {
			if (resp?.success && resp?.data?.length > 0) {
				setHelperText((pre) => {
					pre.isPhoneNumber = "";
					return pre;
				});
				smsApiCall(mobileNo, resp.data[0].email);
				setShowOtp(true);
				const FilterResp = resp.data.filter((v) => v.Leads.length);
				FilterResp.forEach((el) => {
					el.leadStatusObj = defineColorSchema(el.Leads[0]?.LeadStatus[0]?.status);
					// el.leadName=el.Leads[0].personId.name;
					// el.leadId=el.Leads[0].leadId
					el.lastUpdatedOnStatus = el.Leads[0]?.LeadStatus[0]?.last_updated_at;
				});
				localStorage.setItem("LeadList", JSON.stringify(orderBy(FilterResp, "lastUpdatedOnStatus", "desc")));
				if (FilterResp.length > 1) {
					// ? sort leads according to latest lead status
					const sortedLeads = orderBy(FilterResp, "lastUpdatedOnStatus", "desc");
					setLeadsList(sortedLeads);
					// setShowLeadList(true);
					setIsLoginLoading(false);
				} else {
					setLeadsList([]);
					// ! no need of auth here; only set lead done here
					setSelectedLead(FilterResp[0].Leads[0]);
					localStorage.setItem("selectedLead", JSON.stringify(FilterResp[0].Leads[0]));
					// setShowLeadList(false);
					setIsLoginLoading(false);
					// dispatch(actions.authLogin(resp.data[0].Leads[0]));
					// navigate('/Home');
				}
			} else {
				setHelperText((pre) => {
					pre.isPhoneNumber = "Not registered!";
					return pre;
				});
				errorTost("Lead with " + mobileNo + " is not registered!");
			}
		});
		// let leadId = mobileNo.substring(2, 10) + mobileNo.substring(11, 15);
		// console.log('leadId: ', leadId);
		// getLead(leadId).then((resp) => {
		//     console.log('resp: ', resp);
		//     if (resp.length > 0) {
		//         const contactNo = '+' + resp.data[0].personId.contactNumber;
		//         setSelectedLead(resp.data[0]);
		//         setPersonContactNo(contactNo);
		//         if (contactNo.substring(0, 3) === "+91") {
		//             setIsInterNational(true);
		//             // ! uncomment this while deploying
		//             // setIsInterNational(false);
		//         } else {
		//             setIsInterNational(true);
		//         }
		//         setIsLoginLoading(true);
		//         smsApiCall(contactNo);
		//     } else {
		//         errorTost('Invalid Customer ID!');
		//     }
		// }).catch((err) => {
		//     console.log('err: ', err);
		// });
	}
	// function smsApiCall(contactNo, email) {
	// 	setIsLoginLoading(true);
	// 	setResendButton(false);
	// 	// const myTimeout = setTimeout(() => {
	// 	//   setResendButton(true);
	// 	// }, 180000);
	// 	setState((pre) => {
	// 		pre.otp1 = "";
	// 		pre.otp2 = "";
	// 		pre.otp3 = "";
	// 		pre.otp4 = "";
	// 		return { ...pre };
	// 	});
	// 	setShowOtp(true);
	// 	setEnableOtp(false);
	// 	let body = {
	// 		// number: '+919823140243',
	// 		number: contactNo,
	// 		isInterNational: isInterNational,
	// 		email: email,
	// 	};
	// 	sendOTPMessage(body)
	// 		.then((resp) => {
	// 			setShowTimer(true);
	// 			setIsLoginLoading(false);
	// 			if (resp.data.success) {
	// 				var bytes = CryptoJS.AES.decrypt(resp.data.otp, process.env.REACT_APP_CRYPTO_SECRET_KEY);
	// 				var originalText = bytes.toString(CryptoJS.enc.Utf8);
	// 				// console.log("Otp", parseInt(originalText));
	// 				setRecievedOtp(parseInt(originalText));
	// 				// 900000 ;15 min
	// 				const myTimeout = setTimeout(smsTimeOut, 900000);
	// 			} else {
	// 				if (resp?.data?.error?.ErrorMessage) {
	// 					errorTost(resp?.data?.error?.ErrorMessage);
	// 				} else {
	// 					errorTost("Something went wrong");
	// 				}
	// 			}
	// 		})
	// 		.catch((err) => {
	// 			console.log(err);
	// 		});
	// }
function smsApiCall(contactNo, email) {
  setIsLoginLoading(true);
  setResendButton(false);
  setState((pre) => ({
    ...pre,
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  }));
  setShowOtp(true);
  setEnableOtp(false);

  let body = {
    number: contactNo,
    isInterNational: isInterNational,
    email: email,
  };

 sendOTPMessage(body)
  .then((resp) => {
    console.log("Full Response:", resp);
    setShowTimer(true);
    setIsLoginLoading(false);

    if (resp.data) {

		if (!isInterNational && !resp.data.success) {
  errorTost("SMS sending failed. Please try again.");
  return;
}

      // 🔑 Decode Base64 (safe transport) → get AES ciphertext back
	//   console.log("📦 Frontend received safeEncrypted:", resp.data.otp);
      const encryptedBase64 = resp.data.otp;
      const encrypted = atob(encryptedBase64);  // browser-safe decode
	//   console.log("🔒 Frontend ciphertext after atob:", encrypted);

      // 🔓 Now decrypt with the same key
      var bytes = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_CRYPTO_SECRET_KEY);
      var originalText = bytes.toString(CryptoJS.enc.Utf8);
    //   console.log("🔑 Frontend decrypted OTP:", originalText);
      if (!originalText) {
        console.error("Decryption failed! Key or ciphertext mismatch.");
        errorTost("OTP decryption failed, please try again.");
        return;
      }

    //   console.log("Otp (decrypted):", parseInt(originalText));
      setRecievedOtp(parseInt(originalText));

      // 15 min timeout
      setTimeout(smsTimeOut, 900000);
    } else {
      if (resp?.data?.error?.ErrorMessage) {
        console.log("errorMessage============", resp?.data?.error?.ErrorMessage);
        errorTost(resp?.data?.error?.ErrorMessage);
      } else {
        errorTost("Something went wrong");
      }
    }
  })
  .catch((err) => {
    console.error("sendOTPMessage error:", err);
  })

    .catch((err) => {
      console.log(err);
    });
}

	function smsTimeOut() {
		setHelperText((pre) => {
			pre.isPhoneNumber = "Otp has expired.Please resend otp!";
			return { ...pre };
		});
		setShowOtp(true);
		// setVerifiedPhoneNumber(false);
		setOtpTimer(true);
		setState((pre) => {
			pre.otp1 = "";
			pre.otp2 = "";
			pre.otp3 = "";
			pre.otp4 = "";
			return { ...pre };
		});
		setRecievedOtp(null);
		setResendButton(true);
	}
	function optChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}
	function submitOtpAndLogin() {
		let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
		// console.log(finalValue, "recievedOtp", recievedOtp);
		if (parseInt(finalValue) === recievedOtp) {
			setShowOtp(false);
			setShowTimer(false);
			setVerifiedPhoneNumber(true);
			if (!selectedLead) {
				setShowLeadList(true);
			} else {
				setShowLeadList(false);
				// ! add auth here
				signIn(selectedLead);
				// setLoggedInUser(selectedLead);
				// dispatch(actions.authLogin(selectedLead));
				// // setShowOtp(false);
				// navigate("/Home");
			}

			// setLoggedInUser(selectedLead);
			// dispatch(actions.authLogin(selectedLead));
			// // setShowOtp(false);
			// navigate('/Home');
			// getLeadDetails();
		} else {
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP does not match. Please enter valid OTP!");
		}
	}
	const inputfocus = (elmnt) => {
		if (state.otp1 !== "" && state.otp2 !== "" && state.otp3 !== "" && state.otp4 !== "") {
			setEnableOtp(true);
		} else {
			setEnableOtp(false);
		}
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			// const next = elmnt.target.tabIndex - 2;
			// if (next > -1) {
			// 	// elmnt.target.form.elements[next].focus();
			// 	if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			// }
		} else {
			// const next = elmnt.target.tabIndex + 1;
			const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
			if (next < 5) {
				// elmnt.target.form.elements[next].focus();
				if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			}
		}
	};
	function signIn(selectedLead) {
		presentLoader();
		logIn(selectedLead.personId.contactNumber, selectedLead.leadDisplayId)
			.then((loginResp) => {
				if (loginResp) {
					setSelectedLead(selectedLead);
					localStorage.setItem("selectedLead", JSON.stringify(selectedLead));
					dispatch(actions.authLogin(selectedLead));
					// // setShowOtp(false);
					navigate("/Home");
					dismissLoader();
				} else {
					errorTost("Could not login. Try again later!");
					dismissLoader();
				}
			})
			.catch((err) => {
				console.log("err: ", err);
				errorTost("Could not login. Try again later!");
				dismissLoader();
			});
	}
	return (
		<div className={cssClasses.wrapperPage}>
			<div className={cssClasses.backgroundImage}>
				{/* <img
          src={strip1}
          className={cssClasses.strip1}
          alt="backgroundImage"
        ></img> */}
				<img src={strip2} className={cssClasses.strip2} alt="backgroundImage"></img>

				{/* <img
          src={strip4}
          className={cssClasses.strip4}
          alt="backgroundImage"
        ></img> */}
				<img src={strip3} className={cssClasses.strip3} alt="backgroundImage"></img>
				<div></div>

				<div className={cssClasses.registerationBlock}>
					<div>
						<img src={logo} style={{ width: "23rem" }} alt="vj-logo"></img>
					</div>
					<div className={classes.title}>Welcome Back</div>
					{/* <div className={classes.subTitle}>We will send you a One Time Password on this Mobile Number</div> */}
					<div style={{ textAlign: "left", textTransform: "uppercase" }}>
						{!showOtp && !showLeadList && (
							<>
								{/* <CustomInput
                                    value={mobileNo}
                                    label={"Unique Customer Id"}
                                    mandatory={true}
                                    handleChange={(newValue) => {
                                        console.log(newValue);
                                        if (newValue.length <= 15) {
                                            if (newValue.length !== 15) {
                                                setHelperText((pre) => {
                                                    pre.isPhoneNumber = "User Id must be of 14 characters";
                                                    return { ...pre };
                                                });
                                            } else {
                                                setHelperText((pre) => {
                                                    pre.isPhoneNumber = "";
                                                    return { ...pre };
                                                });
                                                setEnableOtp(true);
                                            }
                                            setMobileNo((pre) => {
                                                pre = newValue;
                                                return pre;
                                            });
                                            helperText.isPhoneNumber = "";
                                        }
                                    }}
                                    placeholder="Enter Unique Customer Id"
                                    inputType="label"
                                    helperText={helperText.isPhoneNumber}
                                /> */}
								<PhoneInput
									defaultCountry="IN"
									value={mobileNo}
									placeholder="Enter phone number"
									onChange={(phone) => {
										if (phone !== undefined) {
											if (phone.length >= 1) {
												if (isValidPhoneNumber(phone) === false) {
													setVerifiedPhoneNumber(false);
													helperText.isPhoneNumber = `Please enter valid mobile number`;
													setEnableOtp(false);
												} else {
													helperText.isPhoneNumber = "";
													setVerifiedPhoneNumber(false);

													if (phone.substring(0, 3) === "+91") {
														if (phone.substring(4, 13).length !== 10) {
															helperText.isPhoneNumber = `Please enter valid mobile number`;
														}
														setIsInterNational(false);
													} else {
														setIsInterNational(true);
													}
													helperText.isPhoneNumber = "";
													setEnableOtp(true);
													helperText.isPhoneNumber = "Verifying...";
													IsNumberBlackListed(phone);
												}
											}
										} else {
											helperText.isPhoneNumber = "Please enter mobile number";
											setEnableOtp(false);
										}
										setMobileNo((pre) => {
											pre = phone;
											return pre;
										});
									}}
								/>
								<p
									style={{
										color: "red",
										fontSize: "1.4rem",
										lineHeight: "1.66",
									}}
								>
									{helperText.isPhoneNumber}
								</p>
							</>
						)}

						{showOtp && !showLeadList && (
							<div className={cssClasses.otpResendWrap}>
								<div className={cssClasses.resendOtp}>
									{" "}
									OTP sent to {mobileNo}
									{/* <div className={cssClasses.resendOtp}> OTP sent to {mobileNo.slice(0, 3)} {mobileNo.slice(3, mobileNo.length - 4).replace(/{d}/g, 'X')}{mobileNo.slice(mobileNo.length - 4, 13)}</div> */}
								</div>
								<div className={cssClasses.otpContainer}>
									<input
										className={cssClasses.otpInput}
										id="opt-0"
										name="otp1"
										type="number"
										autoComplete="off"
										value={state.otp1}
										// onKeyPress={keyPressed}
										onChange={(e) => optChange("otp1", e)}
										tabIndex="1"
										maxLength="1"
										onKeyUp={(e) => inputfocus(e)}
										inputMode="numeric"
										pattern="[0-9]*"
									/>
									<input
										id="opt-1"
										name="otp2"
										type="number"
										autoComplete="off"
										className={cssClasses.otpInput}
										value={state.otp2}
										onChange={(e) => optChange("otp2", e)}
										tabIndex="2"
										maxLength="1"
										onKeyUp={(e) => inputfocus(e)}
										inputMode="numeric"
										pattern="[0-9]*"
									/>
									<input
										id="opt-2"
										name="otp3"
										type="number"
										autoComplete="off"
										className={cssClasses.otpInput}
										value={state.otp3}
										onChange={(e) => optChange("otp3", e)}
										tabIndex="3"
										maxLength="1"
										onKeyUp={(e) => inputfocus(e)}
										inputMode="numeric"
										pattern="[0-9]*"
									/>
									<input
										id="opt-3"
										name="otp4"
										type="number"
										autoComplete="off"
										className={cssClasses.otpInput}
										value={state.otp4}
										onChange={(e) => optChange("otp4", e)}
										tabIndex="4"
										maxLength="1"
										onKeyUp={(e) => inputfocus(e)}
										inputMode="numeric"
										pattern="[0-9]*"
									/>
									{/* <div>
                                    <Button
                                        style={{
                                            color: "#ffffff",
                                            backgroundColor: "#155EEF",
                                            fontSize: "1.4rem",
                                            lineHeight: "2rem",
                                        }}
                                        btnName={"Submit OTP"}
                                        clicked={submitOtp}
                                    />
                                </div> */}
								</div>
								<div className={cssClasses.resendWrap}>
									{resendButton && (
										<div
											className={cssClasses.verifyOtp}
											onClick={() => {
												setHelperText((pre) => {
													pre.isPhoneNumber = "";
													return { ...pre };
												});
												getLeadDetails();
												// smsApiCall();
											}}
										>
											Resend Otp
										</div>
									)}
									{showTimer && (
										<div className={cssClasses.resendOtp}>
											{" "}
											OTP timeout in {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
											<CountdownTimer
												startFrom={180}
												onComplete={() => {
													setShowTimer(false);
													setResendButton(true);
													setRecievedOtp(null);
												}}
												timeFormatter={(time) => {
													return (
														<span>
															{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}
														</span>
													);
												}}
											/>
										</div>
									)}
								</div>
							</div>
						)}
						{showLeadList && (
							<div className={cssClasses.leadsWrap}>
								<div className={cssClasses.selectLead}>Please select a CUID to proceed</div>
								{leadsList.map((lead, i) => (
									<Card
										className={cssClasses.leadCard}
										key={i}
										variant="outlined"
										sx={[
											{
												boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
												borderRadius: "0.8rem ",
												marginTop: "2rem",
											},
										]}
										onClick={() => {
											const selectedLead = lead.Leads[0];
											signIn(selectedLead);
											// setSelectedLead(selectedLead);
											// localStorage.setItem("selectedLead", JSON.stringify(selectedLead));
											// dispatch(actions.authLogin(selectedLead));
											// // // setShowOtp(false);
											// navigate("/Home");
										}}
									>
										{/* <div className={cssClasses.leadDetailsWrap}> */}
										<div className={cssClasses.leadDetails}>
											<div>
												{`VJ${lead.Leads[0]?.leadDisplayId?.slice(0, -4) + "-" + lead.Leads[0]?.leadDisplayId?.slice(-4)}`}
											</div>
											<div>
												<LeadStatusChip
													label={lead.Leads[0]?.LeadStatus[0]?.status}
													style={{
														color: lead.leadStatusObj.chipColor,
														backgroundColor: lead.leadStatusObj.chipBackgroundColor,
													}}
													icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
												/>
											</div>
										</div>
										<div className={cssClasses.leadDetails}>
											<div className={cssClasses.leadDetailsWrap}>{lead.name}</div>
											{/* {lead?.Leads[0]?.cpId?.billingName&&( */}
											<div className={cssClasses.leadDetailsWrap}>CP: {lead?.Leads[0]?.cpId?.billingName ?? "-"}</div>

											{/* // )} */}
										</div>
										<div style={{ width: "100%" }}>
											<div className={cssClasses.leadLastUpdate}>
												{new Date(lead.Leads[0]?.LeadStatus[0]?.last_updated_at).toDateString()},{" "}
												{new Date(lead.Leads[0]?.LeadStatus[0]?.last_updated_at).toLocaleTimeString([], {
													hour: "2-digit",
													minute: "2-digit",
												})}
											</div>
										</div>
										{/* </div> */}
									</Card>
								))}
							</div>
						)}
					</div>
					{!showLeadList && !showOtp && (
						<div>
							<FormGroup>
								<FormControlLabel
									control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }} />}
									checked={acceptTermsAndConditions}
									label={
										<div className={classes.radioLabel}>
											I agree with the
											<span
												style={{
													textDecoration: "underline",
													color: "#1570EF",
													marginLeft: "0.5rem",
													zIndex: "5",
												}}
												onClick={() => {
													setAcceptTermsAndConditions(!acceptTermsAndConditions);
													setTermsAndConditionModal(true);
												}}
											>
												Terms and Conditions
											</span>
										</div>
									}
									onChange={(e) => {
										setAcceptTermsAndConditions(e.target.checked);
									}}
								/>
							</FormGroup>
						</div>
					)}
					<div>
						{!showOtp && !showLeadList && (
							<Button
								style={{
									color: "#ffffff",
									backgroundColor: "#1570EF",
								}}
								btnName={"Send OTP"}
								isLoading={isLoginLoading}
								disable={!enableOtp || !acceptTermsAndConditions || helperText.isPhoneNumber !== ""}
								clicked={() => {
									// smsApiCall(mobileNo)
									getLeadDetails();
								}}
							/>
						)}
						{showOtp && !showLeadList && (
							<Button
								style={{
									color: "#ffffff",
									backgroundColor: "#1570EF",
								}}
								btnName={"Submit"}
								isLoading={isLoginLoading}
								disable={!enableOtp}
								clicked={submitOtpAndLogin}
							/>
						)}
					</div>
				</div>
			</div>
			{termsAndConditionModal && (
				<TermsAndCondition
					open={termsAndConditionModal}
					handleClose={() => {
						setTermsAndConditionModal(false);
					}}
				/>
			)}
		</div>
	);
};

export default Login;
